import { render, staticRenderFns } from "./Remove.vue?vue&type=template&id=1299c848&scoped=true"
import script from "./Remove.vue?vue&type=script&lang=js"
export * from "./Remove.vue?vue&type=script&lang=js"
import style0 from "./Remove.vue?vue&type=style&index=0&id=1299c848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1299c848",
  null
  
)

export default component.exports